import React from "react"
import { Box, AspectRatio, Image } from "@chakra-ui/react"

import Link from "@app/components/Link"
import { useRoutes } from "@app/hooks/useRoutes"
import { useConfigContext } from "@app/providers/config"
import { useShopify } from "@app/hooks/useShopify"

type Props = {
  sibling: any
  activeSibling: any
  handleMouseEnter: (sibling: any) => void
}

const ProductSiblingSelectorButton: React.FC<Props> = ({ sibling, activeSibling, handleMouseEnter }) => {
  const {
    settings: { routes },
  } = useConfigContext()
  const { imageNormaliser } = useShopify()
  const { urlResolver } = useRoutes()

  const productMatch = sibling?.shopify?.handle === activeSibling?.shopify?.handle
  const image = imageNormaliser(sibling?.images?.[0], 100)

  return (
    <AspectRatio ratio={6 / 7} background="white" borderRadius="10%" w="76px">
      <Box
        background="white"
        as={Link}
        title={sibling?.colorTitle}
        arial-label={sibling?.colorTitle}
        to={urlResolver(sibling, routes.PRODUCT)?.url}
        width="50px"
        height="60px"
        borderRadius="inherit"
        pos="relative"
        overflow="hidden"
        onMouseEnter={() => handleMouseEnter(sibling)}
        transition="all .3s ease"
        transform="scale(1)"
        _hover={{ transform: "scale(1.05)" }}
        cursor="pointer"
        {...{
          border: "1px solid",
          borderColor: productMatch ? "#D2D2D4" : "transparent",
        }}
      >
        <Image src={image?.src} objectFit="cover" boxSize="100%" objectPosition="center" />
      </Box>
    </AspectRatio>
  )
}

export default React.memo(ProductSiblingSelectorButton)
